module.exports = __webpack_public_path__ + "img/photo-09.c0043226.webp";